import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/base.css'
import moment from 'moment'
import _ from 'lodash'
import * as api from './api'
import * as validate from './util/validate.js'
import * as util from './util/util.js'

// Vue.prototype.$origin = process.env.NODE_ENV === 'development' ? 'http://124.71.195.223:24321' : window.location.origin
Vue.prototype.$origin = process.env.NODE_ENV === 'development' ? 'http://139.224.244.9:8989' : window.location.origin
// Vue.prototype.$origin = process.env.NODE_ENV === 'development' ? 'https://www.nbmcbidding.com' : window.location.origin
Vue.prototype.$api = api
Vue.prototype.$validate = validate
Vue.prototype.$util = util
Vue.prototype.$moment = moment
Vue.prototype.$_ = _
Vue.use(ElementUI)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
